import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserType } from '../enums/user.enum';
import { AuthService } from '../services/auth.service';

export function userTypeGuard(...allowedUserTypes: UserType[]): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const userType = auth.me()?.userType;

    if (userType && allowedUserTypes.includes(userType)) {
      return true;
    }

    return router.createUrlTree(['/dashboard']);
  };
}
